import {
  LIST_REVIEW_SINGLE
} from "../../Types";

export const setListReview = (payload) => {
  return {
    type: LIST_REVIEW_SINGLE,
    payload: payload,
  };
};
